import { NavLink, Link } from "react-router-dom";
import anadaWhiteLogo from "../assets/images/home/aanand-logo-white.svg";
import i18n from "../i18n";
import { useRef, useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import Notify from "../components/notification";

const NewHeader = () => {
    const { t, i18n } = useTranslation();
    const isSwitching = useRef(false);
    const [lang, setLang] = useState(i18n.language);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setIsMenuOpen(false);
            }
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    return (
        <header className="fixed top-6 left-0 right-0 z-50 flex justify-center px-4 w-full h-[70px]">
            <div className="w-full max-w-5xl bg-[#1c1a17]/80 backdrop-blur-md border border-white/5 rounded-[40px] px-6 py-2 flex items-center justify-between shadow-2xl">
                {/* Logo */}
                <Link to="/" className="flex items-center shrink-0">
                    <img src={anadaWhiteLogo} alt="Aanand Logo" className="h-8 md:h-9 object-contain" />
                </Link>

                {/* Mobile Menu Toggle */}
                <button
                    className="lg:hidden text-brand-gold p-2 bg-brand-gold/10 rounded-xl transition-all active:scale-95 z-50 relative"
                    onClick={() => setIsMenuOpen(!isMenuOpen)}
                >
                    <span className="material-symbols-outlined text-3xl font-bold">{isMenuOpen ? 'close' : 'menu'}</span>
                </button>

                {/* Desktop Navigation Links */}
                <nav className="hidden lg:flex items-center gap-6 xl:gap-8">
                    <NavLink className="text-sm font-medium text-slate-300 hover:text-white transition-colors" to="/">
                        {t('menu.home')}
                    </NavLink>
                    <NavLink className="text-sm font-medium text-slate-300 hover:text-white transition-colors" to="/wallet-download">
                        {t('menu.wallet')}
                    </NavLink>
                    <NavLink className="text-sm font-medium text-slate-300 hover:text-white transition-colors" to="/and-event-platform">
                        {t('homeBanner.events')}
                    </NavLink>
                    <a className="text-sm font-medium text-slate-300 hover:text-white transition-colors cursor-pointer" onClick={(e) => { e.preventDefault(); const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); else window.location.href = '/#contact'; }}>
                        {t('menu.support')}
                    </a>
                </nav>

                {/* Desktop Connect Wallet / Launch App */}
                <div className="hidden lg:flex items-center gap-4 shrink-0">
                    <div className="toggle__language scale-75 origin-right whitespace-nowrap">
                        <div
                            onClick={() => {
                                if (isSwitching.current) return;
                                isSwitching.current = true;
                                setTimeout(() => {
                                    const newLang = i18n.language === "ko" ? "en" : "ko";
                                    i18n.changeLanguage(newLang);
                                    setLang(newLang);
                                    isSwitching.current = false;
                                }, 100);
                            }}
                            className="switch m-0 p-0">
                            <input
                                id="language-toggle"
                                className="check-toggle check-toggle-round-flat"
                                type="checkbox"
                                checked={lang === "ko"}
                                readOnly
                            />
                            <label htmlFor="language-toggle"></label>
                            <span className="on" title="English">EN</span>
                            <span className="off" title="Korean">KO</span>
                        </div>
                    </div>

                    <a
                        href="/dashboard"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="h-[42px] px-6 rounded-xl bg-gradient-to-r from-[#d6a512] to-[#ecb613] shadow-[0_0_15px_rgba(236,182,19,0.3)] text-background-dark font-bold text-sm tracking-wide flex items-center justify-center hover:brightness-110 hover:scale-105 transition-all text-nowrap"
                        onClick={(e) => {
                            if (window.location.pathname.includes('/dashboard')) {
                                e.preventDefault();
                                Notify("This is not active and for testing purposes only", "warning");
                            }
                        }}
                    >
                        {t('menu.launch_app')}
                    </a>
                </div>

                {/* Mobile Menu Overlay */}
                {isMenuOpen && (
                    <div className="absolute top-[80px] left-0 right-0 bg-[#1c1a17]/95 backdrop-blur-xl border border-white/10 rounded-3xl p-6 flex flex-col gap-6 shadow-2xl lg:hidden max-h-[80vh] overflow-y-auto z-40">
                        <NavLink className="text-lg font-medium text-slate-200 hover:text-white" to="/" onClick={() => setIsMenuOpen(false)}>{t('menu.home')}</NavLink>

                        <NavLink className="text-lg font-medium text-slate-200 hover:text-white" to="/wallet-download" onClick={() => setIsMenuOpen(false)}>{t('menu.wallet')}</NavLink>
                        <NavLink className="text-lg font-medium text-slate-200 hover:text-white" to="/and-event-platform" onClick={() => setIsMenuOpen(false)}>{t('homeBanner.events')}</NavLink>
                        <a className="text-lg font-medium text-slate-200 hover:text-white cursor-pointer" onClick={(e) => { e.preventDefault(); setIsMenuOpen(false); const el = document.getElementById('contact'); if (el) el.scrollIntoView({ behavior: 'smooth' }); else window.location.href = '/#contact'; }}>{t('menu.support')}</a>

                        <div className="w-full h-px bg-white/10 my-2"></div>

                        <div className="flex items-center justify-between">
                            <span className="text-lg font-medium text-slate-200">Language</span>
                            <div className="toggle__language scale-75 origin-right m-0">
                                <div
                                    onClick={() => {
                                        if (isSwitching.current) return;
                                        isSwitching.current = true;
                                        setTimeout(() => {
                                            const newLang = i18n.language === "ko" ? "en" : "ko";
                                            i18n.changeLanguage(newLang);
                                            setLang(newLang);
                                            isSwitching.current = false;
                                        }, 100);
                                    }}
                                    className="switch m-0">
                                    <input
                                        id="language-toggle-mobile"
                                        className="check-toggle check-toggle-round-flat"
                                        type="checkbox"
                                        checked={lang === "ko"}
                                        readOnly
                                    />
                                    <label htmlFor="language-toggle-mobile"></label>
                                    <span className="on" title="English">EN</span>
                                    <span className="off" title="Korean">KO</span>
                                </div>
                            </div>
                        </div>

                        <a
                            href="/dashboard"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="w-full h-[52px] rounded-xl bg-gradient-to-r from-[#d6a512] to-[#ecb613] text-background-dark font-bold flex items-center justify-center text-lg mt-2"
                            onClick={(e) => {
                                setIsMenuOpen(false);
                                if (window.location.pathname.includes('/dashboard')) {
                                    e.preventDefault();
                                    Notify("This is not active and for testing purposes only", "warning");
                                }
                            }}
                        >
                            {t('menu.launch_app')}
                        </a>
                    </div>
                )}
            </div>
        </header>
    );
};

export default NewHeader;
